var map = {
	".": "CSFx",
	"./": "CSFx",
	"./01_get_contract_allPosition": "ttu5",
	"./01_get_contract_allPosition.json": "ttu5",
	"./02_get_contract_allOrders": "RhU9",
	"./02_get_contract_allOrders.json": "RhU9",
	"./03_get_contract_balance": "n0S/",
	"./03_get_contract_balance.json": "n0S/",
	"./index": "CSFx",
	"./index.js": "CSFx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "Ke1b";


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/standard/api/trade ^.*$
// module id = Ke1b
// module chunks = 3